import { takeLatest } from "redux-saga/effects";
import {
  getEmployeeScheduleListSuccess,
  getEmployeeScheduleListFail,
  getEmployeeScheduleDetailsSuccess,
  getEmployeeScheduleDetailsFail,
  getEmployeeScheduleTemplateOptionsSuccess,
  getEmployeeScheduleTemplateOptionsFail,
} from "./employeeScheduleState";
import createCrudService from "../../services/crudservice";
import {
  doCrudCall,
  SAVING_MSG,
  UPDATING_MSG,
  DELETING_MSG,
  LOADING_MSG,
  createRecordSuccess,
  updateRecordSuccess,
  deleteRecordSuccess,
} from "../../utils/crudSagaHelper";

const crudService = createCrudService(
    "api/v1/workforce/employees"
);

const redirectData = {
  route: "/console/employees",
  mode: "list",
  recordId: 0,
};

const modelName = "Employee Schedule";

function* getEmployeeScheduleList(data) {
    const { employeeId, ...params } = data.payload;
    yield doCrudCall(
        () => crudService.getList(
            params,
            `${employeeId}/employee-schedules`
        ),
        getEmployeeScheduleListSuccess,
        getEmployeeScheduleListFail,
        null,
        null,
        LOADING_MSG
    );
}

function* getEmployeeScheduleDetails(data) {
    const { employeeId, scheduleId } = data.payload;

    yield doCrudCall(
        () => crudService.getDetails(
            scheduleId, `${employeeId}/employee-schedules`
        ),
        getEmployeeScheduleDetailsSuccess,
        getEmployeeScheduleDetailsFail,
        null,
        null,
        LOADING_MSG
    );
}

function* doEmployeeScheduleCreate(data) {
  const employeeId = data.payload.esd_employee_id;
  const childEndpoint = `${employeeId}/employee-schedules`;

  yield doCrudCall(
    () => crudService.doCreate(data.payload, childEndpoint),
    getEmployeeScheduleDetailsSuccess,
    getEmployeeScheduleDetailsFail,
    createRecordSuccess(modelName),
    { ...redirectData, mode: "reload" },
    null,
    SAVING_MSG
  );
}

function* doEmployeeScheduleUpdate(data) {
  const { esd_employee_id, esd_id } = data.payload;
  const childEndpoint = `${esd_employee_id}/employee-schedules`;

  yield doCrudCall(
    () => crudService.doUpdate(esd_id, data.payload, childEndpoint),
    getEmployeeScheduleDetailsSuccess,
    getEmployeeScheduleDetailsFail,
    updateRecordSuccess(modelName),
    { ...redirectData, mode: "reload" },
    null,
    UPDATING_MSG
  );
}

function* doEmployeeScheduleDelete(data) {
  const { esd_employee_id, esd_id } = data.payload;
  const childEndpoint = `${esd_employee_id}/employee-schedules`;

  yield doCrudCall(
    () => crudService.doDelete(esd_id, childEndpoint),
    getEmployeeScheduleDetailsSuccess,
    getEmployeeScheduleDetailsFail,
    deleteRecordSuccess(modelName),
    { ...redirectData, mode: "reload" },
    null,
    DELETING_MSG
  );
}

function* getEmployeeScheduleTemplateOptions(data) {
  yield doCrudCall(
    () =>
      crudService.doGetRequest(
        "schedule-template-options",
        data.payload
      ),
    getEmployeeScheduleTemplateOptionsSuccess,
    getEmployeeScheduleTemplateOptionsFail,
    null,
    null,
    LOADING_MSG
  );
}

function* employeeScheduleSaga() {
  yield takeLatest("employeeSchedule/getEmployeeScheduleList", getEmployeeScheduleList);
  yield takeLatest("employeeSchedule/getEmployeeScheduleDetails",getEmployeeScheduleDetails);
  yield takeLatest("employeeSchedule/doEmployeeScheduleCreate",doEmployeeScheduleCreate);
  yield takeLatest("employeeSchedule/doEmployeeScheduleUpdate",doEmployeeScheduleUpdate);
  yield takeLatest("employeeSchedule/doEmployeeScheduleDelete",doEmployeeScheduleDelete);
  yield takeLatest( "employeeSchedule/getEmployeeScheduleTemplateOptions",getEmployeeScheduleTemplateOptions);
}

export default employeeScheduleSaga;